/* Dominion theme JS - measured motion, no dependencies */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var reduceMotion =
    docEl.getAttribute('data-reduce-motion') === 'true' ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Trust bar count-up ---------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count-to')) || 0;
    var decimals = (String(el.getAttribute('data-count-to')).split('.')[1] || '').length;
    var duration = 1000;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3); /* ease-out cubic */
      el.textContent = (target * eased).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCountUp() {
    var nums = document.querySelectorAll('[data-count-to]');
    if (!nums.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nums.forEach(function (el) {
        var v = parseFloat(el.getAttribute('data-count-to')) || 0;
        var d = (String(el.getAttribute('data-count-to')).split('.')[1] || '').length;
        el.textContent = v.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    nums.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Reading progress ---------- */
  function initProgress() {
    var bar = document.querySelector('.reading-progress__fill');
    var body = document.querySelector('[data-progress-target]');
    if (!bar || !body) return;
    function update() {
      var rect = body.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = rect.height - vh;
      var done = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 1;
      bar.style.width = (done * 100).toFixed(2) + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Table of contents ---------- */
  function initToc() {
    var toc = document.getElementById('article-toc');
    var prose = document.querySelector('.article-prose');
    if (!toc || !prose) return;
    var heads = prose.querySelectorAll('h2, h3');
    if (heads.length < 2) { toc.style.display = 'none'; return; }

    var frag = document.createDocumentFragment();
    heads.forEach(function (h, i) {
      if (!h.id) {
        h.id = 'sec-' + i + '-' + h.textContent.trim().toLowerCase()
          .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 48);
      }
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      if (h.tagName === 'H3') a.classList.add('is-h3');
      frag.appendChild(a);
    });
    toc.appendChild(frag);

    if (!reduceMotion && 'IntersectionObserver' in window) {
      var links = toc.querySelectorAll('a');
      var map = {};
      links.forEach(function (l) { map[l.getAttribute('href').slice(1)] = l; });
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            links.forEach(function (l) { l.classList.remove('is-active'); });
            var link = map[entry.target.id];
            if (link) link.classList.add('is-active');
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach(function (h) { spy.observe(h); });
    }
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = document.querySelector('.site-header');
    var toggle = document.querySelector('.nav-toggle');
    var mobileNav = document.getElementById('mobile-nav');
    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    if (toggle && mobileNav) {
      toggle.addEventListener('click', function () {
        var open = mobileNav.classList.toggle('is-open');
        document.body.classList.toggle('nav-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  ready(function () {
    initReveal();
    initCountUp();
    initProgress();
    initToc();
    initHeader();
  });
})();
